<div class="contents-wrapper flex flex-col full-grow-no-shrink-no-basis" *ngIf="!showFilterEditWindow"
     [id]="feedContentId">

    <mat-accordion class="activity-mat-accordion" multi="true">
        <mat-expansion-panel #panel
                             (opened)="onOpen()"
                             (closed)="onClose()"
                             [expanded]="isExpanded"
                             [id]="feedInfo?.id">
            <mat-expansion-panel-header [collapsedHeight]="'auto'" [expandedHeight]="'auto'">
                <mat-panel-title>
            <span class="title-text full-grow-no-shrink-no-basis"
                  matTooltip="{{feedInfo?.title}}">{{feedInfo?.title}}</span>
                </mat-panel-title>
                <button mat-icon-button class="icon-dropdown-button" [matMenuTriggerFor]="filterNameOption"
                        (click)="onMenuClick()">
                    <i class="fa-solid fa-ellipsis"></i>
                </button>
            </mat-expansion-panel-header>
            <div class="contents flex flex-col full-grow-no-shrink-no-basis">
                <div class="project-details flex flex-col">
                    <mat-menu #filterNameOption="matMenu" class="right v2-0-menu" [overlapTrigger]="false">
                        <button mat-menu-item class="flex flex-row justify-start items-center"
                                (click)="refreshFeedInfo(feedInfo)">
                            <i class="far fa-sync-alt"></i>
                            <span>Refresh</span>
                        </button>
                        <!--<button mat-menu-item class="flex flex-row justify-start items-center"
                                (click)="activityHeaderFilterChange()">
                            <i class="fas fa-pencil-alt"></i>
                            <span>Date Range</span>
                        </button>
                        <button mat-menu-item class="flex flex-row justify-start items-center"
                                (click)="onExportActivityFeed(feedContentId,'Excel')">
                            <i class="far fa-file-export"></i>
                            <span>Export (Excel) - Up to 1,000 items</span>
                        </button>-->
                        <button mat-menu-item class="flex flex-row justify-start items-center"
                                (click)="onSelectAddComment($event)">
                            <i class="fa-solid fa-message"></i>
                            <span>Add comment</span>
                        </button>
                        <button mat-menu-item class="flex flex-row justify-start items-center"
                                (click)="onNotificationSettings($event)"
                                *ngIf="feedInfo && feedInfo.type && feedInfo.type.toLowerCase() === activityFeedTypes.ReferenceCode.toLowerCase()">
                            <i class="far fa-bell-exclamation"></i>
                            <span>Notifications</span>
                        </button>
                    </mat-menu>
                    <div class="orbitax-publication"
                         *ngIf="hasDefaultPublication && feedInfo && feedInfo.isDefault === true && feedInfo.type.toLowerCase() === activityFeedTypes.Tool.toLowerCase()"
                         (click)="onDefaultPublicationClicked()">View latest Orbitax Publication changes
                    </div>
                </div>
                <div class="comments simple-scroll full-grow-no-shrink-no-basis"
                     *ngIf="!isDirtyActivities && conversationsByFilter && conversationsByFilter.conversations && conversationsByFilter.conversations.length > 0"
                     #listScroll>
                    <div *ngFor="let conversation of conversationsByFilter.conversations">
                        <particle-activity
                                class="particle-kanban-board-card"
                                [feedInfo]="feedInfo"
                                [conversation]="conversation"
                                [allContacts]="feedInfo && feedInfo.contactsList && feedInfo.contactsList.length > 0? feedInfo.contactsList: allContacts"
                                [hashTagList]="hashTagList"
                                [isMagicLinkOnly]="isMagicLinkOnly"
                                [impersonationId]="feedInfo.impersonationId"
                                [hideGotoPage]="feedInfo.sourceKey === 'ExpertService'"
                                (newFeedInfo$)="onAddNewFeed($event)"
                        >
                        </particle-activity>
                        <div class="other-msg" *ngIf="conversationId===conversation.id && conversationsByFilter.conversations.length > 1
        && conversationsByFilter.conversation">Other Activities
                        </div>
                    </div>
                </div>
                <button *ngIf="!conversationsByFilter && feedInfo && !feedInfo.isUserAction"
                        class="show-contacts"
                        style="width: calc(100% - 40px)" (click)="viewActivity()">View Activities
                </button>
                <div class="flex flex-row justify-center items-start"
                     *ngIf="!isDirtyActivities && conversationsByFilter &&
                     (!platformLink?.fieldValues?.isStepByStepEnabled && platformLink?.fieldValues?.ScenarioType === 'GMT')
                     && (!conversationsByFilter.conversations || conversationsByFilter.conversations.length===0)">
                    <div class="empty-section">
                        <i class="fa-regular fa-clock-rotate-left"></i>
                        <p>To track the activity for this scenario, please enable the Step-by-Step Sidebar via the
                            Actions menu on the scenario overview screen.</p>
                    </div>
                </div>
                <div class="flex flex-row justify-center items-start"
                     *ngIf="!isDirtyActivities && conversationsByFilter &&
                   !(!platformLink?.fieldValues?.isStepByStepEnabled && platformLink?.fieldValues?.ScenarioType === 'GMT')
                   && (!conversationsByFilter.conversations || conversationsByFilter.conversations.length===0)">
                    <div class="empty-section">
                        <i class="fa-regular fa-clock-rotate-left"></i>
                        <p>There is currently no activity available for this screen.</p>
                    </div>
                    <div class="empty-section v2-0-sidebar">
                        <picture>
                            <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 70 70"
                                 fill="none">
                                <g clip-path="url(#clip0_3606_27)">
                                    <rect width="70" height="70" rx="35" fill="#3747D6"/>
                                    <rect x="-1" y="9.69922" width="36" height="6.25" fill="#90CAEA"/>
                                    <rect x="-1" y="20.6992" width="36" height="6.25" fill="#90CAEA"/>
                                    <rect x="-1" y="31.6992" width="36" height="6.25" fill="#90CAEA"/>
                                    <rect x="-1" y="42.9004" width="36" height="6.25" fill="#90CAEA"/>
                                    <rect x="-1" y="54" width="36" height="6.25" fill="#90CAEA"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_3606_27">
                                        <rect width="70" height="70" rx="35" fill="white"/>
                                    </clipPath>
                                </defs>
                            </svg>
                        </picture>
                        <p class="sub-title">There is currently no activity available for this screen.</p>
                    </div>

                </div>
                <div class="p-20 flex flex-row justify-center items-start"
                     *ngIf="!isDirtyActivities && errorOccured">
                    <em>Error occurred.</em>
                </div>
                <particle-right-sidebar-wait-screen
                        *ngIf="isDirtyActivities && feedInfo && feedInfo.isUserAction"></particle-right-sidebar-wait-screen>
            </div>
            <div class="feed-footer flex flex-row justify-start items-center"
                 *ngIf="conversationsByFilter && !isDirtyActivities && !errorOccured">
                <strong>{{conversationsByFilter?.startIndex}}</strong>&nbsp;to&nbsp;<strong>{{conversationsByFilter?.endIndex}}</strong>&nbsp;of&nbsp;
                <strong>{{conversationsByFilter?.recordCount | number}}</strong>&nbsp;results
                <div class="pagination-container m-l-auto">
                    <button mat-button [disabled]="conversationsByFilter?.pageNo <= 0" (click)="pagination('back')">
                        <i class="fal fa-chevron-left"></i>
                    </button>
                    <button mat-button [disabled]="conversationsByFilter?.pageNo >= conversationsByFilter?.pageCount-1"
                            (click)="pagination('forward')">
                        <i class="fal fa-chevron-right"></i>
                    </button>
                </div>
            </div>
            <div id="chatEditor-{{feedInfo?.id}}" class="editor"
                 *ngIf="conversationsByFilter && !isDirtyActivities && conversationsByFilter.referenceCode">
                <particle-text-editor
                        *ngIf="showChatEditor || data?.showChatEditor"
                        [editorId]="commentEditorId"
                        [chatText]="draftCommentText"
                        [hideFileAttachment]="feedInfo.isUseImpersonation"
                        [allContacts]="feedInfo && feedInfo.contactsList && feedInfo.contactsList.length > 0? feedInfo.contactsList: allContacts"
                        [hashTagList]="hashTagList"
                        [mention$]="mention$"
                        [hideDac6CardLink]="true"
                        [replyToMessage]="null"
                        [focusEditor$]="focusEditorOnChatEditor$"
                        [disableEnterToSendMessage]="true"
                        (outputChatEditorEvent)="onAddComment($event)"
                        (cancelChatEditor)="onCancelChatEditor($event)"
                        (outputEditorInnerHtmlOnChangeEvent)="onEditorValueChange($event)"
                >
                </particle-text-editor>
                <div class="m-tb-10 activity-information-container flex flex-row justify-center items-center"
                     *ngIf="realTimeUpdateInfo.hasNewReply || realTimeUpdateInfo.hasNewActivity">
          <span>
          <span *ngIf="realTimeUpdateInfo.hasNewActivity">{{realTimeUpdateInfo.newActivityCount}} new
        <span *ngIf="realTimeUpdateInfo.newActivityCount < 2">activity</span>
        <span *ngIf="realTimeUpdateInfo.newActivityCount > 1">activities</span>
        <span *ngIf="realTimeUpdateInfo.hasNewReply"> and </span>
        </span>
          <span *ngIf="realTimeUpdateInfo.hasNewReply">{{realTimeUpdateInfo.newReplyCount}} new
        <span *ngIf="realTimeUpdateInfo.newReplyCount < 2">reply</span>
        <span *ngIf="realTimeUpdateInfo.newReplyCount > 1">replies</span>
        </span>
          <span *ngIf="realTimeUpdateInfo.hasNewReply || realTimeUpdateInfo.hasNewActivity"> found.<a
                  *ngIf="realTimeUpdateInfo.hasNewReply || realTimeUpdateInfo.hasNewActivity"
                  (click)="miningAndUpdateFeedInfo(feedInfo)">Refresh</a></span>
        </span>
                    <span>.</span>

                </div>
            </div>
        </mat-expansion-panel>
    </mat-accordion>
</div>
<particle-activity-tracker-filter
        *ngIf="showFilterEditWindow && feedInfo && feedInfo.type && feedInfo.type.toLowerCase() === activityFeedTypes.Filter.toLowerCase()"
        [filterId]="feedInfo.id"
        [handler]="handler"
        [saveFilter$]="saveFilter$"
        [setFeedOnRightSidebar]="setFeedOnRightSidebar"
        (onAddNewFilter$)="onAddNewFilter($event)"
        (applyFilter$)="invalidateFilter($event)"
        (cancelFilter$)="onCancelFilter($event)">
</particle-activity-tracker-filter>
